module.exports = __webpack_public_path__ + "img/img01.7317ce75.png";